<template>
  <div class="container py-4">
    <div class="page-card">
      <div
        class="d-flex justify-content-between align-items-start mb-3 flex-wrap gap-2"
      >
        <div>
          <h4 class="mb-0 section-title-accent">Reports</h4>
          <p class="small text-muted mb-0">
            Operational, financial, GRA tax, and audit reports
          </p>
        </div>
        <icon-button
          :func="() => refreshAll()"
          :icon="'rotate-right'"
          :title="'Refresh all reports'"
          :classes="'akkurate-green-btn'"
          :btnName="''"
        />
      </div>

      <div class="report-filters p-3 mb-3">
        <div class="row g-2 align-items-end">
          <div class="col-md-3">
            <label class="small text-muted mb-1">Range start</label>
            <b-form-input
              class="form-control"
              v-model="filters.startDate"
              type="date"
              size="sm"
            />
          </div>
          <div class="col-md-3">
            <label class="small text-muted mb-1">Range end</label>
            <b-form-input
              class="form-control"
              v-model="filters.endDate"
              type="date"
              size="sm"
            />
          </div>
          <div class="col-md-3">
            <label class="small text-muted mb-1">Daily sales date</label>
            <b-form-input
              class="form-control"
              v-model="filters.dailyDate"
              type="date"
              size="sm"
            />
          </div>
          <div class="col-md-3">
            <icon-button
              :func="() => refreshAll()"
              :icon="''"
              :title="'Refresh all reports'"
              :classes="'akkurate-green-btn w-100'"
              :btnName="'Apply'"
            />
            <!-- <b-button size="sm" class="akkurate-green-btn" @click="refreshAll"
              >Apply</b-button
            > -->
          </div>
        </div>
      </div>

      <div class="report-browser p-3 mb-3">
        <div
          class="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-2"
        >
          <h6 class="mb-0">Report browser</h6>
          <report-export-buttons
            v-if="activeReportDef?.exportKey"
            :report-key="activeReportDef.exportKey"
            :params="browserExportParams"
          />
        </div>
        <div class="row g-2 align-items-end">
          <div class="col-md-3">
            <label class="small text-muted mb-1">Category</label>
            <b-form-select
              v-model="reportCategory"
              size="sm"
              :options="reportCategories"
              class="akkurate_input filter-list filter-list-choice status-filter custom-select form-select"
              @change="onCategoryChange"
            />
          </div>
          <div class="col-md-4">
            <label class="small text-muted mb-1">Report</label>
            <b-form-select
              v-model="activeReportKey"
              size="sm"
              :options="reportsInCategory"
              class="akkurate_input filter-list filter-list-choice status-filter custom-select form-select"
              @change="loadBrowserReport"
            />
          </div>
          <div v-if="activeReportDef?.extra === 'customerId'" class="col-md-3">
            <label class="small text-muted mb-1">Customer</label>
            <b-form-select
              v-model="selectedCustomerId"
              size="sm"
              :options="customerOptions"
              class="akkurate_input filter-list filter-list-choice status-filter custom-select form-select"
              @change="loadBrowserReport"
            />
          </div>
          <div v-if="activeReportDef?.extra === 'topN'" class="col-md-2">
            <label class="small text-muted mb-1">Top N</label>
            <b-form-input
              class="form-control"
              v-model.number="browserTopN"
              type="number"
              min="1"
              max="100"
              size="sm"
              @change="loadBrowserReport"
            />
          </div>
          <div v-if="activeReportDef?.extra === 'priceType'" class="col-md-2">
            <label class="small text-muted mb-1">Price type</label>
            <b-form-select
              v-model="browserPriceType"
              size="sm"
              class="akkurate_input filter-list filter-list-choice status-filter custom-select form-select"
              :options="priceTypeOptions"
              @change="loadBrowserReport"
            />
          </div>
          <div v-if="activeReportDef?.extra === 'periodType'" class="col-md-2">
            <label class="small text-muted mb-1">Period</label>
            <b-form-select
              v-model="profitPeriodType"
              size="sm"
              class="akkurate_input filter-list filter-list-choice status-filter custom-select form-select"
              :options="profitPeriodOptions"
              @change="loadBrowserReport"
            />
          </div>
          <div
            v-if="activeReportDef?.extra === 'taxPeriodType'"
            class="col-md-2"
          >
            <label class="small text-muted mb-1">Period</label>
            <b-form-select
              v-model="taxPeriodType"
              size="sm"
              class="akkurate_input filter-list filter-list-choice status-filter custom-select form-select"
              :options="taxPeriodOptions"
              @change="loadBrowserReport"
            />
          </div>
          <div class="col-md-2">
            <icon-button
              :func="() => loadBrowserReport()"
              :icon="'arrow-right'"
              :title="'Load report'"
              :classes="'akkurate-green-btn btn-size2'"
              :btnName="'Load'"
            />
          </div>
        </div>
        <p v-if="browserError" class="text-danger small mt-3 mb-0">
          {{ browserError }}
        </p>
        <report-summary-cards
          v-if="!browserLoading && browserLoaded && browserSummary"
          class="mt-3"
          :cards="browserSummary"
        />
        <p
          v-if="
            !browserLoading &&
            browserLoaded &&
            activeReportKey === 'x-reading' &&
            browserData?.payload
          "
          class="mt-3 mb-0"
        >
          <report-summary-cards :cards="xReadingCards" />
        </p>
        <b-table
          v-if="browserItems.length"
          class="mt-3"
          :items="browserItems"
          :fields="browserFields"
          small
          responsive
          :busy="browserLoading"
        >
          <template
            v-for="field in moneyBrowserFields"
            #[`cell(${field.key})`]="data"
          >
            {{ formatMoney(data.value) }}
          </template>
          <template
            v-for="field in datetimeBrowserFields"
            #[`cell(${field.key})`]="data"
          >
            {{ formatDateTime(data.value) }}
          </template>
        </b-table>
        <p
          v-else-if="
            !browserLoading &&
            browserLoaded &&
            !browserSummary &&
            !browserError &&
            !(activeReportKey === 'x-reading' && browserData?.payload)
          "
          class="text-muted small mt-3 mb-0"
        >
          No data for this report.
        </p>
        <div v-if="reportCategory === 'fiscal'" class="mt-3 d-flex gap-2">
          <b-button
            size="sm"
            class="akkurate-green-btn"
            :disabled="fiscalLoading"
            @click="runZReading"
          >
            Run Z reading (end of day)
          </b-button>
        </div>
      </div>

      <b-tabs>
        <!-- Operational -->
        <b-tab title="Daily sales" title-item-class="akkurate-link-btn">
          <report-summary-cards v-if="daily" :cards="dailyCards" />
          <h6 class="mt-3">Payments by method</h6>
          <b-table
            :items="daily?.paymentsByMethod || []"
            :fields="paymentFields"
            small
            responsive
          />
          <h6 class="mt-3">Top products</h6>
          <b-table
            :items="daily?.productPerformance || []"
            :fields="productFields"
            small
            responsive
          />
        </b-tab>

        <b-tab title="Sales trend" title-item-class="akkurate-link-btn">
          <div class="d-flex gap-2 mb-3 flex-wrap align-items-center mt-2">
            <b-form-radio-group
              v-model="trendPeriod"
              :options="periodOptions"
              buttons
              button-variant="outline-secondary btn-size2"
              @change="loadTrend"
            />
            <b-form-select
              v-if="trendPeriod === 'daily'"
              class="p-0 m-1 akkurate_input filter-list filter-list-choice status-filter custom-select"
              v-model="trendDays"
              :options="daysOptions"
              style="width: auto"
              @change="loadTrend"
            />
          </div>
          <div v-if="trendPoints.length" class="trend-chart">
            <div
              v-for="point in trendPoints"
              :key="point.date"
              class="trend-bar-row"
            >
              <span class="trend-label">{{ point.label }}</span>
              <div class="trend-bar-track">
                <div
                  class="trend-bar-fill"
                  :style="{ width: barWidth(point.totalAmount) }"
                />
              </div>
              <span class="trend-value">{{
                formatMoney(point.totalAmount)
              }}</span>
            </div>
          </div>
          <p v-else class="text-muted">No sales data for this period.</p>
        </b-tab>

        <b-tab title="Sales by user" title-item-class="akkurate-link-btn">
          <b-table
            class="mt-2"
            :items="salesByUser"
            :fields="salesByUserFields"
            small
            responsive
          >
            <template #cell(totalAmount)="data">{{
              formatMoney(data.value)
            }}</template>
          </b-table>
        </b-tab>

        <b-tab title="Product performance" title-item-class="akkurate-link-btn">
          <b-table
            class="mt-2"
            :items="productPerformance"
            :fields="productPerfFields"
            small
            responsive
          >
            <template #cell(totalRevenue)="data">{{
              formatMoney(data.value)
            }}</template>
            <template #cell(averagePrice)="data">{{
              formatMoney(data.value)
            }}</template>
          </b-table>
        </b-tab>

        <b-tab title="Stock levels" title-item-class="akkurate-link-btn">
          <b-table
            class="mt-2"
            :items="stockLevels"
            :fields="stockFields"
            small
            responsive
          />
        </b-tab>

        <b-tab title="Revenue by category" title-item-class="akkurate-link-btn">
          <b-table
            class="mt-2"
            :items="revenueByCategory"
            :fields="categoryFields"
            small
            responsive
          >
            <template #cell(totalRevenue)="data">{{
              formatMoney(data.value)
            }}</template>
          </b-table>
        </b-tab>

        <b-tab title="Sales by hour" title-item-class="akkurate-link-btn">
          <div
            class="d-flex justify-content-between align-items-center mt-2 mb-2 flex-wrap gap-2"
          >
            <p v-if="salesByHour?.overall" class="small text-muted mb-0">
              {{ salesByHour.overall.transactionCount }} transactions ·
              {{ formatMoney(salesByHour.overall.totalSales) }}
            </p>
            <report-export-buttons
              report-key="sales-by-hour"
              :params="rangeParams"
            />
          </div>
          <b-table
            :items="salesByHour?.hours || []"
            :fields="hourFields"
            small
            responsive
          >
            <template #cell(totalSales)="data">{{
              formatMoney(data.value)
            }}</template>
            <template #cell(averageTransaction)="data">{{
              formatMoney(data.value)
            }}</template>
          </b-table>
        </b-tab>

        <b-tab title="Voided sales" title-item-class="akkurate-link-btn">
          <div
            class="d-flex justify-content-between align-items-center mt-2 mb-2 flex-wrap gap-2"
          >
            <p v-if="voidedSalesReport?.summary" class="small text-muted mb-0">
              {{ voidedSalesReport.summary.totalTransactions }} voided/refunded
              ·
              {{ formatMoney(voidedSalesReport.summary.totalAmount) }}
            </p>
            <report-export-buttons
              report-key="voided-sales"
              :params="rangeParams"
            />
          </div>
          <b-table
            :items="voidedSalesReport?.sales || []"
            :fields="voidedFields"
            small
            responsive
          >
            <template #cell(total)="data">{{
              formatMoney(data.value)
            }}</template>
            <template #cell(voidedAt)="data">{{
              formatDateTime(data.value)
            }}</template>
            <template #cell(status)="data">
              <b-badge :variant="statusVariant(data.value)">{{
                data.value
              }}</b-badge>
            </template>
          </b-table>
        </b-tab>

        <b-tab title="Cash reconciliation" title-item-class="akkurate-link-btn">
          <div
            class="d-flex justify-content-between align-items-center mt-2 mb-2 flex-wrap gap-2"
          >
            <p v-if="cashReconciliation?.summary" class="small text-muted mb-0">
              {{ cashReconciliation.summary.balancedCount }} balanced ·
              {{ cashReconciliation.summary.shortCount }} short ·
              {{ cashReconciliation.summary.overCount }} over
            </p>
            <report-export-buttons
              report-key="cash-reconciliation"
              :params="rangeParams"
            />
          </div>
          <b-table
            :items="cashReconciliation?.reconciliations || []"
            :fields="cashReconFields"
            small
            responsive
          >
            <template #cell(expectedCash)="data">{{
              formatMoney(data.value)
            }}</template>
            <template #cell(countedCash)="data">{{
              formatMoney(data.value)
            }}</template>
            <template #cell(variance)="data">{{
              formatMoney(data.value)
            }}</template>
            <template #cell(closedAt)="data">{{
              formatDateTime(data.value)
            }}</template>
            <template #cell(varianceType)="data">
              <b-badge :variant="varianceVariant(data.value)">{{
                data.value
              }}</b-badge>
            </template>
          </b-table>
        </b-tab>

        <b-tab title="Profit margin" title-item-class="akkurate-link-btn">
          <div
            class="d-flex justify-content-between align-items-center mt-2 mb-2 flex-wrap gap-2"
          >
            <p v-if="profitMargin?.overall" class="small text-muted mb-0">
              Gross profit {{ formatMoney(profitMargin.overall.grossProfit) }} ·
              {{ profitMargin.overall.profitMarginPercent }}% margin
            </p>
            <report-export-buttons
              report-key="profit-margin"
              :params="rangeParams"
            />
          </div>
          <b-table
            :items="profitMargin?.products || []"
            :fields="profitMarginFields"
            small
            responsive
          >
            <template #cell(totalRevenue)="data">{{
              formatMoney(data.value)
            }}</template>
            <template #cell(totalCost)="data">{{
              formatMoney(data.value)
            }}</template>
            <template #cell(grossProfit)="data">{{
              formatMoney(data.value)
            }}</template>
          </b-table>
        </b-tab>

        <b-tab title="COGS" title-item-class="akkurate-link-btn">
          <div
            class="d-flex justify-content-between align-items-center mt-2 mb-2 flex-wrap gap-2"
          >
            <p v-if="cogsReport?.overall" class="small text-muted mb-0">
              COGS {{ formatMoney(cogsReport.overall.totalCogs) }} · Gross
              profit {{ formatMoney(cogsReport.overall.grossProfit) }}
            </p>
            <report-export-buttons report-key="cogs" :params="rangeParams" />
          </div>
          <b-table
            :items="cogsReport?.lines || []"
            :fields="cogsFields"
            small
            responsive
          >
            <template #cell(unitCost)="data">{{
              formatMoney(data.value)
            }}</template>
            <template #cell(totalCogs)="data">{{
              formatMoney(data.value)
            }}</template>
            <template #cell(totalRevenue)="data">{{
              formatMoney(data.value)
            }}</template>
            <template #cell(grossProfit)="data">{{
              formatMoney(data.value)
            }}</template>
          </b-table>
        </b-tab>

        <b-tab title="Profit summary" title-item-class="akkurate-link-btn">
          <div
            class="d-flex justify-content-between align-items-center mt-2 mb-2 flex-wrap gap-2"
          >
            <b-form-select
              v-model="profitPeriodType"
              :options="profitPeriodOptions"
              size="sm"
              style="width: auto"
              class="akkurate_input filter-list filter-list-choice status-filter custom-select form-select"
              @change="loadProfitSummary"
            />
            <report-export-buttons
              report-key="profit-summary"
              :params="{ ...rangeParams, periodType: profitPeriodType }"
            />
          </div>
          <b-table
            :items="profitSummary?.periods || []"
            :fields="profitSummaryFields"
            small
            responsive
          >
            <template #cell(totalRevenue)="data">{{
              formatMoney(data.value)
            }}</template>
            <template #cell(totalCogs)="data">{{
              formatMoney(data.value)
            }}</template>
            <template #cell(grossProfit)="data">{{
              formatMoney(data.value)
            }}</template>
          </b-table>
        </b-tab>

        <b-tab title="Inventory valuation" title-item-class="akkurate-link-btn">
          <div
            class="d-flex justify-content-between align-items-center mt-2 mb-2 flex-wrap gap-2"
          >
            <p v-if="inventoryValuation?.summary" class="small text-muted mb-0">
              Stock value
              {{ formatMoney(inventoryValuation.summary.totalInventoryValue) }}
              · Retail
              {{ formatMoney(inventoryValuation.summary.totalRetailValue) }}
            </p>
            <report-export-buttons
              report-key="inventory-valuation"
              :params="{ storeId: selectedStoreId }"
            />
          </div>
          <b-table
            :items="inventoryValuation?.items || []"
            :fields="inventoryValFields"
            small
            responsive
          >
            <template #cell(costPrice)="data">{{
              formatMoney(data.value)
            }}</template>
            <template #cell(unitPrice)="data">{{
              formatMoney(data.value)
            }}</template>
            <template #cell(inventoryValue)="data">{{
              formatMoney(data.value)
            }}</template>
            <template #cell(retailValue)="data">{{
              formatMoney(data.value)
            }}</template>
          </b-table>
        </b-tab>

        <!-- GRA Tax -->
        <b-tab title="GRA: VAT" title-item-class="akkurate-link-btn">
          <div
            class="d-flex justify-content-between align-items-center mt-2 mb-2 flex-wrap gap-2"
          >
            <p v-if="vatReport?.overall" class="small text-muted mb-0">
              Total VAT {{ formatMoney(vatReport.overall.totalVat) }} on
              {{ formatMoney(vatReport.overall.totalSales) }} sales
            </p>
            <report-export-buttons report-key="vat" :params="rangeParams" />
          </div>
          <b-table
            :items="vatReport?.summaries || []"
            :fields="vatFields"
            small
            responsive
          >
            <template #cell(totalSales)="data">{{
              formatMoney(data.value)
            }}</template>
            <template #cell(totalVat)="data">{{
              formatMoney(data.value)
            }}</template>
          </b-table>
        </b-tab>

        <b-tab title="GRA: NHIL & GETFund" title-item-class="akkurate-link-btn">
          <div class="d-flex justify-content-end mt-2 mb-2">
            <report-export-buttons
              report-key="nhil-getfund"
              :params="rangeParams"
            />
          </div>
          <b-table
            class="mt-2"
            :items="nhilReport?.summaries || []"
            :fields="nhilFields"
            small
            responsive
          >
            <template #cell(totalSales)="data">{{
              formatMoney(data.value)
            }}</template>
            <template #cell(totalNhil)="data">{{
              formatMoney(data.value)
            }}</template>
            <template #cell(totalGetFund)="data">{{
              formatMoney(data.value)
            }}</template>
            <template #cell(totalNhilGetFund)="data">{{
              formatMoney(data.value)
            }}</template>
          </b-table>
        </b-tab>

        <b-tab title="GRA: Tax by period" title-item-class="akkurate-link-btn">
          <b-form-select
            v-model="taxPeriodType"
            :options="taxPeriodOptions"
            size="sm"
            class="mt-2 mb-3 akkurate_input filter-list filter-list-choice status-filter custom-select"
            style="width: auto"
            @change="loadTaxPeriod"
          />
          <b-table
            :items="taxPeriodReport?.summaries || []"
            :fields="taxPeriodFields"
            small
            responsive
          >
            <template #cell(totalSales)="data">{{
              formatMoney(data.value)
            }}</template>
            <template #cell(totalTax)="data">{{
              formatMoney(data.value)
            }}</template>
          </b-table>
        </b-tab>

        <b-tab title="GRA: Tax by product" title-item-class="akkurate-link-btn">
          <b-table
            class="mt-2"
            :items="taxProductReport?.summaries || []"
            :fields="taxProductFields"
            small
            responsive
          >
            <template #cell(totalRevenue)="data">{{
              formatMoney(data.value)
            }}</template>
            <template #cell(totalTax)="data">{{
              formatMoney(data.value)
            }}</template>
          </b-table>
        </b-tab>

        <b-tab title="GRA: Zero-rated" title-item-class="akkurate-link-btn">
          <b-table
            class="mt-2"
            :items="zeroRatedReport?.summaries || []"
            :fields="zeroRatedFields"
            small
            responsive
          >
            <template #cell(totalSales)="data">{{
              formatMoney(data.value)
            }}</template>
            <template #cell(zeroRatedSales)="data">{{
              formatMoney(data.value)
            }}</template>
            <template #cell(exemptSales)="data">{{
              formatMoney(data.value)
            }}</template>
          </b-table>
        </b-tab>

        <!-- GRA Audit -->
        <b-tab title="Audit: Transactions" title-item-class="akkurate-link-btn">
          <div class="d-flex justify-content-end mt-2 mb-2">
            <report-export-buttons
              report-key="transaction-log"
              :params="rangeParams"
            />
          </div>
          <b-table
            class="mt-2"
            :items="transactionLog?.entries || []"
            :fields="transactionFields"
            small
            responsive
          >
            <template #cell(amount)="data">{{
              formatMoney(data.value)
            }}</template>
            <template #cell(occurredAt)="data">{{
              formatDateTime(data.value)
            }}</template>
          </b-table>
        </b-tab>

        <b-tab title="Audit: Receipts" title-item-class="akkurate-link-btn">
          <div class="d-flex justify-content-end mt-2 mb-2">
            <report-export-buttons
              report-key="receipt-listing"
              :params="rangeParams"
            />
          </div>
          <b-table
            class="mt-2"
            :items="receiptListing?.receipts || []"
            :fields="receiptFields"
            small
            responsive
          >
            <template #cell(total)="data">{{
              formatMoney(data.value)
            }}</template>
            <template #cell(completedAt)="data">{{
              formatDateTime(data.value)
            }}</template>
          </b-table>
        </b-tab>

        <b-tab title="Audit: Trail" title-item-class="akkurate-link-btn">
          <b-table
            class="mt-2"
            :items="auditTrail?.entries || []"
            :fields="auditFields"
            small
            responsive
          >
            <template #cell(createdAt)="data">{{
              formatDateTime(data.value)
            }}</template>
          </b-table>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ApiService from "@/core/services/api.service";
import ReportSummaryCards from "./ReportSummaryCards.vue";
import ReportExportButtons from "./ReportExportButtons.vue";
import {
  REPORT_CATALOG,
  REPORT_CATEGORIES,
  REPORT_FIELDS,
} from "./reportCatalog";
import IconButton from "@/components/IconButton.vue";

function isoDate(d) {
  return d.toISOString().slice(0, 10);
}

export default {
  name: "Reports",
  components: { ReportSummaryCards, ReportExportButtons, IconButton },
  data() {
    const today = new Date();
    const monthAgo = new Date();
    monthAgo.setDate(monthAgo.getDate() - 30);
    return {
      loading: false,
      filters: {
        startDate: isoDate(monthAgo),
        endDate: isoDate(today),
        dailyDate: isoDate(today),
      },
      daily: null,
      stockLevels: [],
      revenueByCategory: [],
      salesByUser: [],
      productPerformance: [],
      trendPoints: [],
      trendMax: 0,
      trendPeriod: "daily",
      trendDays: 30,
      profitPeriodType: "Daily",
      salesByHour: null,
      voidedSalesReport: null,
      cashReconciliation: null,
      profitMargin: null,
      cogsReport: null,
      profitSummary: null,
      inventoryValuation: null,
      taxPeriodType: "Daily",
      vatReport: null,
      nhilReport: null,
      taxPeriodReport: null,
      taxProductReport: null,
      zeroRatedReport: null,
      transactionLog: null,
      receiptListing: null,
      auditTrail: null,
      reportCategory: "operations",
      activeReportKey: "sales-by-payment",
      browserData: null,
      browserLoading: false,
      browserLoaded: false,
      browserError: null,
      selectedCustomerId: null,
      customerOptions: [],
      browserTopN: 10,
      browserPriceType: "All",
      fiscalLoading: false,
      priceTypeOptions: [
        { value: "All", text: "All" },
        { value: "SellingPrice", text: "Selling price" },
        { value: "CostPrice", text: "Cost price" },
      ],
      reportCategories: REPORT_CATEGORIES,
      periodOptions: [
        { text: "Daily", value: "daily" },
        { text: "Monthly", value: "monthly" },
      ],
      daysOptions: [
        { value: 7, text: "7 days" },
        { value: 30, text: "30 days" },
        { value: 60, text: "60 days" },
        { value: 90, text: "90 days" },
      ],
      taxPeriodOptions: [
        { value: "Daily", text: "Daily" },
        { value: "Weekly", text: "Weekly" },
        { value: "Monthly", text: "Monthly" },
      ],
      profitPeriodOptions: [
        { value: "Daily", text: "Daily" },
        { value: "Monthly", text: "Monthly" },
      ],
      paymentFields: [
        { key: "method", label: "Method" },
        { key: "count", label: "Count" },
        { key: "totalAmount", label: "Amount" },
      ],
      productFields: [
        { key: "productSku", label: "SKU" },
        { key: "productName", label: "Product" },
        { key: "quantitySold", label: "Qty" },
        { key: "totalAmount", label: "Revenue" },
      ],
      salesByUserFields: [
        { key: "userName", label: "Cashier" },
        { key: "storeName", label: "Store" },
        { key: "salesCount", label: "Sales" },
        { key: "totalAmount", label: "Total" },
      ],
      productPerfFields: [
        { key: "productSku", label: "SKU" },
        { key: "productName", label: "Product" },
        { key: "quantitySold", label: "Qty" },
        { key: "totalRevenue", label: "Revenue" },
        { key: "averagePrice", label: "Avg price" },
      ],
      stockFields: [
        { key: "productSku", label: "SKU" },
        { key: "productName", label: "Product" },
        { key: "quantity", label: "Qty" },
        { key: "available", label: "Available" },
        { key: "isLowStock", label: "Low stock" },
      ],
      categoryFields: [
        { key: "category", label: "Category" },
        { key: "quantitySold", label: "Qty" },
        { key: "productCount", label: "Products" },
        { key: "totalRevenue", label: "Revenue" },
      ],
      hourFields: [
        { key: "hourLabel", label: "Hour" },
        { key: "transactionCount", label: "Transactions" },
        { key: "totalSales", label: "Total sales" },
        { key: "averageTransaction", label: "Avg transaction" },
      ],
      voidedFields: [
        { key: "saleNumber", label: "Sale #" },
        { key: "status", label: "Status" },
        { key: "storeName", label: "Store" },
        { key: "cashierName", label: "Cashier" },
        { key: "total", label: "Total" },
        { key: "voidedAt", label: "Date" },
      ],
      cashReconFields: [
        { key: "closedAt", label: "Closed" },
        { key: "storeName", label: "Store" },
        { key: "userName", label: "Cashier" },
        { key: "expectedCash", label: "Expected" },
        { key: "countedCash", label: "Counted" },
        { key: "variance", label: "Variance" },
        { key: "varianceType", label: "Type" },
      ],
      profitMarginFields: [
        { key: "productSku", label: "SKU" },
        { key: "productName", label: "Product" },
        { key: "category", label: "Category" },
        { key: "quantitySold", label: "Qty" },
        { key: "totalRevenue", label: "Revenue" },
        { key: "totalCost", label: "Cost" },
        { key: "grossProfit", label: "Gross profit" },
        { key: "profitMarginPercent", label: "Margin %" },
      ],
      cogsFields: [
        { key: "date", label: "Date" },
        { key: "saleNumber", label: "Sale #" },
        { key: "productSku", label: "SKU" },
        { key: "productName", label: "Product" },
        { key: "quantitySold", label: "Qty" },
        { key: "unitCost", label: "Unit cost" },
        { key: "totalCogs", label: "COGS" },
        { key: "totalRevenue", label: "Revenue" },
        { key: "grossProfit", label: "Gross profit" },
      ],
      profitSummaryFields: [
        { key: "periodLabel", label: "Period" },
        { key: "transactionCount", label: "Transactions" },
        { key: "totalRevenue", label: "Revenue" },
        { key: "totalCogs", label: "COGS" },
        { key: "grossProfit", label: "Gross profit" },
        { key: "marginPercent", label: "Margin %" },
      ],
      inventoryValFields: [
        { key: "productSku", label: "SKU" },
        { key: "productName", label: "Product" },
        { key: "category", label: "Category" },
        { key: "storeName", label: "Store" },
        { key: "quantity", label: "Qty" },
        { key: "costPrice", label: "Cost" },
        { key: "unitPrice", label: "Unit price" },
        { key: "inventoryValue", label: "Stock value" },
        { key: "retailValue", label: "Retail value" },
      ],
      vatFields: [
        { key: "date", label: "Date" },
        { key: "storeName", label: "Store" },
        { key: "transactionCount", label: "Txns" },
        { key: "totalSales", label: "Sales" },
        { key: "totalVat", label: "VAT" },
        { key: "vatPercentage", label: "VAT %" },
      ],
      nhilFields: [
        { key: "date", label: "Date" },
        { key: "storeName", label: "Store" },
        { key: "totalNhil", label: "NHIL" },
        { key: "totalGetFund", label: "GETFund" },
        { key: "totalNhilGetFund", label: "Total" },
        { key: "totalSales", label: "Sales" },
      ],
      taxPeriodFields: [
        { key: "periodLabel", label: "Period" },
        { key: "storeName", label: "Store" },
        { key: "transactionCount", label: "Txns" },
        { key: "totalSales", label: "Sales" },
        { key: "totalTax", label: "Tax" },
      ],
      taxProductFields: [
        { key: "productSku", label: "SKU" },
        { key: "productName", label: "Product" },
        { key: "category", label: "Category" },
        { key: "quantitySold", label: "Qty" },
        { key: "totalTax", label: "Tax" },
        { key: "totalRevenue", label: "Revenue" },
      ],
      zeroRatedFields: [
        { key: "date", label: "Date" },
        { key: "storeName", label: "Store" },
        { key: "zeroRatedCount", label: "Zero-rated txns" },
        { key: "zeroRatedSales", label: "Zero-rated" },
        { key: "exemptCount", label: "Exempt txns" },
        { key: "exemptSales", label: "Exempt" },
      ],
      transactionFields: [
        { key: "occurredAt", label: "When" },
        { key: "type", label: "Type" },
        { key: "reference", label: "Reference" },
        { key: "storeName", label: "Store" },
        { key: "userName", label: "User" },
        { key: "amount", label: "Amount" },
        { key: "status", label: "Status" },
      ],
      receiptFields: [
        { key: "completedAt", label: "Date" },
        { key: "receiptNumber", label: "Receipt #" },
        { key: "saleNumber", label: "Sale #" },
        { key: "cashierName", label: "Cashier" },
        { key: "total", label: "Total" },
      ],
      auditFields: [
        { key: "createdAt", label: "When" },
        { key: "action", label: "Action" },
        { key: "entityType", label: "Entity" },
        { key: "userName", label: "User" },
        { key: "ipAddress", label: "IP" },
      ],
    };
  },
  computed: {
    ...mapGetters(["selectedStoreId", "currencySymbol"]),
    rangeParams() {
      return {
        storeId: this.selectedStoreId,
        startDate: this.filters.startDate,
        endDate: this.filters.endDate,
      };
    },
    dailyCards() {
      if (!this.daily) return [];
      return [
        { label: "Sales count", value: this.daily.totalSales },
        {
          label: "Total amount",
          value: this.daily.totalAmount,
          format: "money",
        },
        { label: "Tax", value: this.daily.totalTax, format: "money" },
        { label: "Discount", value: this.daily.totalDiscount, format: "money" },
      ];
    },
    reportsInCategory() {
      return REPORT_CATALOG.filter(
        (r) => r.category === this.reportCategory,
      ).map((r) => ({
        value: r.key,
        text: r.label,
      }));
    },
    activeReportDef() {
      return REPORT_CATALOG.find((r) => r.key === this.activeReportKey) || null;
    },
    browserItems() {
      if (!this.browserData || !this.activeReportDef) return [];
      if (this.activeReportDef.itemsKey) {
        return this.browserData[this.activeReportDef.itemsKey] || [];
      }
      if (Array.isArray(this.browserData)) return this.browserData;
      return [];
    },
    browserFields() {
      if (!this.activeReportDef) return [];
      const def = this.activeReportDef;
      const catalogFields =
        (def.itemsKey && REPORT_FIELDS[def.itemsKey]) ||
        REPORT_FIELDS[def.key] ||
        null;
      if (catalogFields) {
        return catalogFields.filter((f) => {
          if (!this.browserItems.length) return true;
          return f.key in this.browserItems[0] || f.key === "rank";
        });
      }
      if (this.browserItems.length) {
        return this.inferBrowserFields(this.browserItems[0]);
      }
      return [];
    },
    moneyBrowserFields() {
      return this.browserFields.filter((f) => f.format === "money");
    },
    datetimeBrowserFields() {
      return this.browserFields.filter((f) => f.format === "datetime");
    },
    browserExportParams() {
      const p = { ...this.rangeParams };
      if (this.activeReportDef?.extra === "topN") p.topN = this.browserTopN;
      if (this.activeReportDef?.extra === "priceType")
        p.priceType = this.browserPriceType;
      if (this.activeReportDef?.extra === "periodType")
        p.periodType = this.profitPeriodType;
      if (this.activeReportDef?.extra === "taxPeriodType")
        p.periodType = this.taxPeriodType;
      if (
        this.activeReportDef?.extra === "customerId" &&
        this.selectedCustomerId
      ) {
        p.customerId = this.selectedCustomerId;
      }
      return p;
    },
    browserSummary() {
      if (!this.browserData || Array.isArray(this.browserData)) return null;
      if (this.browserData.compliance) {
        const c = this.browserData.compliance;
        return [
          { label: "Filing period", value: c.filingPeriod },
          { label: "Due date", value: c.dueDate },
          { label: "Status", value: c.status },
          { label: "Balance due", value: c.balanceDue, format: "money" },
        ];
      }
      const source = this.browserData.summary || this.browserData.overall;
      if (source && typeof source === "object" && !Array.isArray(source)) {
        return Object.entries(source).map(([k, v]) => ({
          label: k
            .replace(/([A-Z])/g, " $1")
            .replace(/^./, (x) => x.toUpperCase()),
          value:
            typeof v === "number" && this.isSummaryMoneyKey(k) ? v : String(v),
          format:
            typeof v === "number" && this.isSummaryMoneyKey(k)
              ? "money"
              : undefined,
        }));
      }
      if (typeof this.browserData.totalAmount === "number") {
        return [
          { label: "Sales count", value: this.browserData.totalSales },
          {
            label: "Total amount",
            value: this.browserData.totalAmount,
            format: "money",
          },
          { label: "Tax", value: this.browserData.totalTax, format: "money" },
          {
            label: "Discount",
            value: this.browserData.totalDiscount,
            format: "money",
          },
        ];
      }
      return null;
    },
    xReadingCards() {
      const p = this.browserData?.payload;
      if (!p) return [];
      return [
        {
          label: "Reading",
          value: `${this.browserData.readingType}-${this.browserData.readingNumber}`,
        },
        { label: "Transactions", value: p.transactionCount },
        { label: "Gross sales", value: p.grossSales, format: "money" },
        { label: "Total tax", value: p.totalTax, format: "money" },
        { label: "Voided", value: p.voidedCount },
      ];
    },
  },
  watch: {
    selectedStoreId() {
      this.refreshAll();
    },
  },
  mounted() {
    this.refreshAll();
    this.loadCustomers();
    this.loadBrowserReport();
  },
  methods: {
    isSummaryMoneyKey(key) {
      return /total|amount|balance|revenue|profit|tax|sales|income|expense|cogs|value|float|cash|vat|nhil|fund|payable|receivable/i.test(
        key,
      );
    },
    inferBrowserFields(row) {
      const moneyRe =
        /amount|revenue|price|cost|profit|cogs|value|income|expense|discount|cash|float|payable|receivable|vat|nhil|fund|tax$|total$/i;
      const datetimeRe =
        /(At|Date)$|^(date|openedAt|closedAt|changedAt|createdAt|completedAt|occurredAt|voidedAt)$/i;
      return Object.keys(row)
        .filter((k) => {
          const v = row[k];
          return (
            v === null || ["string", "number", "boolean"].includes(typeof v)
          );
        })
        .map((k) => ({
          key: k,
          label: k
            .replace(/([A-Z])/g, " $1")
            .replace(/^./, (x) => x.toUpperCase())
            .trim(),
          format: datetimeRe.test(k)
            ? "datetime"
            : typeof row[k] === "number" &&
              moneyRe.test(k) &&
              !/count|qty|quantity|percent|rank|hour|points/i.test(k)
            ? "money"
            : undefined,
        }));
    },
    onCategoryChange() {
      const first = REPORT_CATALOG.find(
        (r) => r.category === this.reportCategory,
      );
      this.activeReportKey = first?.key || "";
      this.loadBrowserReport();
    },
    async loadCustomers() {
      try {
        const list = await ApiService.get("customers", { limit: 200 });
        this.customerOptions = [
          { value: null, text: "Select customer" },
          ...list.map((c) => ({
            value: c.id,
            text: c.fullName || `${c.firstName} ${c.lastName}`,
          })),
        ];
      } catch {
        this.customerOptions = [];
      }
    },
    async loadBrowserReport() {
      const def = this.activeReportDef;
      if (!def) return;
      if (def.extra === "customerId" && !this.selectedCustomerId) {
        this.browserData = null;
        this.browserLoaded = false;
        this.browserError = null;
        return;
      }
      if (def.key === "x-reading" && !this.selectedStoreId) {
        this.browserData = null;
        this.browserLoaded = true;
        this.browserError = "Select a store to run an X reading.";
        return;
      }
      this.browserLoading = true;
      this.browserError = null;
      try {
        const params = { storeId: this.selectedStoreId };
        if (def.dateFilter !== "none" && def.dateFilter !== "daily") {
          params.startDate = this.filters.startDate;
          params.endDate = this.filters.endDate;
        }
        if (def.dateFilter === "daily") params.date = this.filters.dailyDate;
        if (def.extra === "topN") params.topN = this.browserTopN;
        if (def.extra === "priceType") params.priceType = this.browserPriceType;
        if (def.extra === "periodType")
          params.periodType = this.profitPeriodType;
        if (def.extra === "taxPeriodType")
          params.periodType = this.taxPeriodType;
        if (def.extra === "customerId")
          params.customerId = this.selectedCustomerId;
        if (def.key === "sales-trend") {
          params.period = this.trendPeriod;
          if (this.trendPeriod === "daily") params.days = this.trendDays;
        }
        this.browserData = await ApiService.get(def.endpoint, params);
        this.browserLoaded = true;
      } catch (e) {
        this.browserData = null;
        this.browserLoaded = true;
        this.browserError =
          e?.response?.data?.message || "Could not load this report.";
      } finally {
        this.browserLoading = false;
      }
    },
    async runZReading() {
      if (!this.selectedStoreId) return;
      this.fiscalLoading = true;
      try {
        const result = await ApiService.post("reports/z-reading", {
          storeId: this.selectedStoreId,
        });
        this.browserData = result;
        this.browserLoaded = true;
        this.activeReportKey = "x-reading";
        toast.fire({
          title: `Z reading #${result.readingNumber} recorded`,
          icon: "success",
        });
      } catch (e) {
        toast.fire({
          title: e?.response?.data?.message || "Z reading failed",
          icon: "danger",
        });
      } finally {
        this.fiscalLoading = false;
      }
    },
    formatDateTime(iso) {
      if (!iso) return "—";
      return new Date(iso).toLocaleString();
    },
    statusVariant(status) {
      if (status === "voided" || status === "cancelled") return "warning";
      if (status === "refunded") return "info";
      return "secondary";
    },
    varianceVariant(type) {
      if (type === "Balanced") return "success";
      if (type === "Over") return "info";
      if (type === "Short") return "danger";
      return "secondary";
    },
    barWidth(amount) {
      if (!this.trendMax) return "0%";
      return `${Math.max(2, (amount / this.trendMax) * 100)}%`;
    },
    assignIfOk(result, fallback) {
      return result.status === "fulfilled" ? result.value : fallback;
    },
    async refreshAll() {
      this.loading = true;
      try {
        await Promise.allSettled([
          this.loadDaily(),
          this.loadOperational(),
          this.loadFinancialReports(),
          this.loadTrend(),
          this.loadGraReports(),
          this.loadAuditReports(),
          this.loadBrowserReport(),
        ]);
      } finally {
        this.loading = false;
      }
    },
    async loadDaily() {
      try {
        this.daily = await ApiService.get("reports/daily", {
          storeId: this.selectedStoreId,
          date: this.filters.dailyDate,
        });
      } catch {
        /* keep prior data */
      }
    },
    async loadOperational() {
      const p = this.rangeParams;
      const results = await Promise.allSettled([
        ApiService.get("reports/stock-levels", {
          storeId: this.selectedStoreId,
        }),
        ApiService.get("reports/revenue-by-category", p),
        ApiService.get("reports/sales-by-user", p),
        ApiService.get("reports/product-performance", p),
      ]);
      this.stockLevels = this.assignIfOk(results[0], this.stockLevels);
      this.revenueByCategory = this.assignIfOk(
        results[1],
        this.revenueByCategory,
      );
      this.salesByUser = this.assignIfOk(results[2], this.salesByUser);
      this.productPerformance = this.assignIfOk(
        results[3],
        this.productPerformance,
      );
    },
    async loadFinancialReports() {
      const p = this.rangeParams;
      const results = await Promise.allSettled([
        ApiService.get("reports/sales-by-hour", p),
        ApiService.get("reports/voided-sales", p),
        ApiService.get("reports/cash-reconciliation", p),
        ApiService.get("reports/profit-margin", p),
        ApiService.get("reports/cogs", p),
        ApiService.get("reports/inventory-valuation", {
          storeId: this.selectedStoreId,
        }),
      ]);
      this.salesByHour = this.assignIfOk(results[0], this.salesByHour);
      this.voidedSalesReport = this.assignIfOk(
        results[1],
        this.voidedSalesReport,
      );
      this.cashReconciliation = this.assignIfOk(
        results[2],
        this.cashReconciliation,
      );
      this.profitMargin = this.assignIfOk(results[3], this.profitMargin);
      this.cogsReport = this.assignIfOk(results[4], this.cogsReport);
      this.inventoryValuation = this.assignIfOk(
        results[5],
        this.inventoryValuation,
      );
      await this.loadProfitSummary();
    },
    async loadProfitSummary() {
      try {
        this.profitSummary = await ApiService.get("reports/profit-summary", {
          ...this.rangeParams,
          periodType: this.profitPeriodType,
        });
      } catch {
        /* keep prior data */
      }
    },
    async loadTrend() {
      try {
        const params = {
          storeId: this.selectedStoreId,
          period: this.trendPeriod,
        };
        if (this.trendPeriod === "daily") params.days = this.trendDays;
        const trend = await ApiService.get("reports/sales-trend", params);
        this.trendPoints = trend.points || [];
        this.trendMax = Math.max(
          0,
          ...this.trendPoints.map((pt) => pt.totalAmount),
        );
      } catch {
        /* keep prior data */
      }
    },
    async loadGraReports() {
      const p = this.rangeParams;
      const results = await Promise.allSettled([
        ApiService.get("reports/vat", p),
        ApiService.get("reports/nhil-getfund", p),
        ApiService.get("reports/tax-summary-by-product", p),
        ApiService.get("reports/zero-rated-exempt", p),
      ]);
      this.vatReport = this.assignIfOk(results[0], this.vatReport);
      this.nhilReport = this.assignIfOk(results[1], this.nhilReport);
      this.taxProductReport = this.assignIfOk(
        results[2],
        this.taxProductReport,
      );
      this.zeroRatedReport = this.assignIfOk(results[3], this.zeroRatedReport);
      await this.loadTaxPeriod();
    },
    async loadTaxPeriod() {
      try {
        this.taxPeriodReport = await ApiService.get(
          "reports/tax-collected-by-period",
          {
            ...this.rangeParams,
            periodType: this.taxPeriodType,
          },
        );
      } catch {
        /* keep prior data */
      }
    },
    async loadAuditReports() {
      const p = this.rangeParams;
      const results = await Promise.allSettled([
        ApiService.get("reports/transaction-log", p),
        ApiService.get("reports/receipt-listing", p),
        ApiService.get("reports/audit-trail", p),
      ]);
      this.transactionLog = this.assignIfOk(results[0], this.transactionLog);
      this.receiptListing = this.assignIfOk(results[1], this.receiptListing);
      this.auditTrail = this.assignIfOk(results[2], this.auditTrail);
    },
  },
};
</script>

<style scoped>
.report-filters label {
  display: block;
}
.trend-chart {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.trend-bar-row {
  display: grid;
  grid-template-columns: 4.5rem 1fr 5.5rem;
  gap: 0.5rem;
  align-items: center;
  font-size: 0.85rem;
}
.trend-label {
  color: #6c757d;
}
.trend-bar-track {
  background: #f1f3f5;
  border-radius: 4px;
  height: 1.25rem;
  overflow: hidden;
}
.trend-bar-fill {
  background: #2d6a4f;
  height: 100%;
  border-radius: 4px;
  min-width: 2px;
}
.trend-value {
  text-align: right;
  font-variant-numeric: tabular-nums;
}
</style>
